import React from 'react'

import { theme } from '../../resources/theme'

export const ColorContext = React.createContext({
  theme,
})
